import { render } from "./ForgotPass.vue?vue&type=template&id=30048e8a&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=30048e8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30048e8a"]])

export default __exports__